export default __webpack_public_path__ + "static/Retail-Photo1-83b8aacb951ae4e167320d8eace91d45.png";